import useLogin from 'logic/Auth/useLogin'
import useVerifySms from 'logic/Auth/useVerifySms'
import {useCallback, useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {useNavigate} from 'react-router-dom'
import analyticsService from 'services/analytic'
import {usePageLaunch} from 'services/hooks'
import storage from 'services/storage'

const useLoginScreen = () => {
    usePageLaunch('login')
    const navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState()
    const [showSmsVerification, setShowSmsVerification] = useState(false)

    const [loginData, setLoginData] = useState(null)

    const {
        isLoading: isLoadingVerifySms,
        doVerifySms,
        doSendSms,
        verifySmsError,
        ulth,
        clearVerifySmsError,
        resetTime,
        timeStr,
    } = useVerifySms()

    const onRequestSmsVerification = useCallback(() => {
        setShowSmsVerification(true)
    }, [])

    const {
        isLoading: isLoadingLogin,
        doLogin,
        loginResponse,
        loginError,
        clearLoginError,
    } = useLogin(onRequestSmsVerification)

    useEffect(() => {
        if (ulth) {
            doLogin(loginData, ulth)
        }
    }, [doLogin, loginData, ulth])

    useEffect(() => {
        if (loginResponse) {
            navigate('/dashboard')
            window.location.reload()
        }
    }, [loginResponse, navigate])

    useEffect(() => {
        if (verifySmsError) {
            setErrorMessage(verifySmsError)
        }
    }, [verifySmsError])

    useEffect(() => {
        if (loginError) {
            setErrorMessage(loginError)
        }
    }, [loginError])

    const {
        handleSubmit,
        control,
        formState: {errors},
        getValues,
        watch,
    } = useForm()

    const username = watch('username')

    const onVerifySms = useCallback(() => {
        console.log('verify sms', getValues())
        const {sms, username} = getValues()
        doVerifySms({phone: username, sms})
        analyticsService.verificationExistingUserPressedLaunch()
    }, [doVerifySms, getValues])

    const handleSendSms = useCallback(() => {
        const {username} = getValues()
        resetTime()
        doSendSms({
            phone: username,
        })
        analyticsService.verificationExistingUserPressedSendAgain()
    }, [doSendSms, getValues, resetTime])

    const onSubmit = (submittedData) => {
        console.log('submit data', submittedData)
        setErrorMessage(null)
        clearLoginError()
        clearVerifySmsError()
        storage.setRememberMe(submittedData.rememberMe || false)
        setLoginData(submittedData)
        resetTime()
        doLogin(submittedData)
    }

    const login = handleSubmit(onSubmit)

    return {
        login,
        control,
        errors,
        errorMessage,
        isLoadingVerifySms,
        isLoadingLogin,
        loginErrorMessage: loginError?.data?.message?.message,
        verifySmsErrorMessage: verifySmsError?.data?.message?.message,
        onVerifySms,
        showSmsVerification,
        setShowSmsVerification,
        handleSendSms,
        username,
        timeStr,
    }
}

export default useLoginScreen
